<template>
  <div>
    <p class="check-report-title">清洁单号：<span>{{cleanOrderNo}}</span></p>
    <Card v-for="(checkItem, index) in checkObjectList" :key="index" class="check-report-item">
      <p slot="title">{{`${checkItem.name}（${checkItem.type===1? '关联物品' : '无物品'}）`}}</p>
      <Form v-for="(goods, index) in checkItem.goodsList" :key="`goods-${index}`" :class="{'check-report-goods': checkItem.type===1}">
        <section v-if="checkItem.type===1">
          <FormItem label="物品：" :label-width="84">
            <span>{{`${goods.goodsId}_${goods.goodsName}${goods.goodsDesc ? '_'+goods.goodsDesc : ''}（${goods.isStandard===1?'标配':'选配'}）`}}</span>
          </FormItem>
          <Row v-if="goods.checkType === 1 || goods.checkType === 3" type="flex" align="middle">
            <FormItem label="总数：" :label-width="84">
              <span>{{goods.goodsNum}}</span>
            </FormItem>
            <FormItem label="核查数量：" :label-width="84" class="add-distance">
              <span :class="{'text-danger': goods.checkNum !== goods.goodsNum}">{{goods.checkNum}}</span>
            </FormItem>
          </Row>
        </section>
        <section v-if="goods.checkType === 2 || goods.checkType === 3 || goods.damageType !== 0">
          <FormItem label="步骤标准：" :label-width="84">
            <span>{{goods.damageType===1? '核查无误' : goods.damageType===2 ? '已报损' : ''}}</span>
          </FormItem>
          <FormItem v-show="goods.damageType===2" label="报损描述：" :label-width="84">
            <span>{{goods.damageDescribe}}</span>
          </FormItem>
        </section>
      </Form>
    </Card>
    <Card v-show="feedback.length > 0" class="check-report-item">
      <p slot="title">其他审查反馈</p>
      <Form>
        <FormItem label="反馈描述：" prop="createDate" :label-width="84">
          <p>{{feedback}}</p>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          checkObjectList: [],
          cleanOrderNo: '',
          feedback: ''
        }
      }
    }
  },
  watch: {
    data() {
      this.initData();
    }
  },
  data() {
    return {
      checkObjectList: [],
      cleanOrderNo: '',
      feedback: ''
    }
  },
  methods: {
    initData() {
      
      this.checkObjectList = this.data.checkObjectList;
      this.cleanOrderNo = this.data.cleanOrderNo;
      this.feedback = this.data.feedback !== null ? this.data.feedback : '';
    }
  }
}
</script>

<style lang="scss" scoped>
.check-report-title{
  font-size: 14px;
  margin-bottom: 12px;
}
.check-report-row{
  padding: 8px 4px;
  &.title{
    color: #333;
    font-size: 14px;
    font-weight: 800;
    border-bottom: 2px solid #e9eaec;
  }
}
.check-report-item{
  margin-bottom: 12px;
  .check-report-goods{
    margin-bottom: 12px;
    padding: 0 12px;
    border: 1px solid #e9eaec;
  }
  span{
    color: #495060;
    font-size: 14px;
    &.text-danger{
      color: #ed3f14;
    }
  }
}
.add-distance{
  margin-left: 14px;
}
</style>





// WEBPACK FOOTER //
// src/pages/cleaner/order-list/check-report.vue